<div class="form" *appFilesAppContext>
  <div class="form-date">{{ file?.createdAt | dateFormat : 'date' }}</div>

  <h2 class="form-title">
    <app-icon
      class="form-heading-title-icon"
      [name]="hasFileLink(file) ? 'link-bold' : 'file'"
      [style.color]="file?.color"
    />
    {{ file?.title }}
  </h2>

  @if (file) {
    <app-shared-tags
      class="form-tags"
      [stitchItem]="file"
      [stateKey]="StateKey.tagsList"
    />

    <app-shared-knots
      class="form-knots"
      [stitchItem]="file"
      [stateKey]="StateKey.knotsList"
    />
  }

  <app-shared-signup-cta />

  @if (file?.id && !hasFileLink(file)) {
    <app-file-preview
      class="form-preview h-400 block"
      [file]="file"
    />
  }

  <div
    class="form-actions"
    [class.disabled]="!file?.id"
  >
    @if (hasFileLink(file)) {
      @if (isValidFileLink(file?.link)) {
        <a [href]="file.link" target="_blank" rel="noopener" aria-label="Open file link in a new tab">{{ file.link }}</a>
      } @else {
        <p>{{ file?.link }}</p><p>This file link cannot be opened.</p>
      }
    } @else {
      <button type="button" class="form-actions-button" aria-label="Download file" (click)="download()">
        <app-icon name="download-large" aria-hidden="true" />
      </button>
    }

  </div>

  <div class="form-details">
    <div class="form-details-row">
      <div class="form-details-row-title">Folder</div>
      <div class="form-details-row-input">{{ file?.folderId }}</div>
    </div>

    <div class="form-details-row">
      <div class="form-details-row-title">Description</div>
      <stch-item-description class="form-details-row-input" stchHighlightText [html]="file?.description" />
    </div>
  </div>
</div>
